module.exports = __webpack_public_path__ + "assets/img/picture10.7e7219a0.svg";